import React, { useState, useEffect } from "react";
import { FileText, Calendar, Globe, Award, CheckCircle, ChevronLeft, ChevronRight } from "lucide-react";
import "../styles/FormationsSeminaires.css";
import { supabase } from '../services/supabase';

const iconMap = {
  FileText: FileText,
  Calendar: Calendar,
  Globe: Globe,
  Award: Award,
  CheckCircle: CheckCircle
};

export default function FormationsSeminaires() {
  const [data, setData] = useState({
    title: '',
    items: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchFormationsData();
  }, []);

  const fetchFormationsData = async () => {
    try {
      const { data: formationsData, error } = await supabase
        .from('formations_seminaires')
        .select('*')
        .single();

      if (error) {
        console.error('Supabase error:', error);
        setError('Failed to load formations content');
        return;
      }

      if (formationsData) {
        setData({
          title: formationsData.title || '',
          items: formationsData.items || []
        });
      }
    } catch (error) {
      console.error('Error fetching formations data:', error);
      setError('Failed to load formations content');
    } finally {
      setLoading(false);
    }
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? data.items.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === data.items.length - 1 ? 0 : prev + 1));
  };

  const handleItemSelect = (index) => {
    setCurrentIndex(index);
  };

  if (loading) {
    return <div className="formations-section loading">Loading formations...</div>;
  }

  if (error) {
    return <div className="formations-section error">Error: {error}</div>;
  }

  if (!data.items.length) {
    return <div className="formations-section empty">No formations available</div>;
  }

  const currentItem = data.items[currentIndex];
  const IconComponent = iconMap[currentItem.icon] || FileText;

  return (
    <section className="formations-section" id="formations-seminaires">
      <h2 className="formations-title">{data.title}</h2>

      <div className="formations-card no-border-radius">
        <div className="card-content">
          <div className="card-info">
            {/* <div className="card-icon">
              <IconComponent className={`icon ${currentItem.iconColor}`} />
            </div> */}
            <h3 className="card-title">{currentItem.title}</h3>
            <p className="card-description">{currentItem.description}</p>
            
            {/* New button system */}
            {currentItem.buttons && currentItem.buttons.length > 0 && (
              <div className="card-buttons">
                {currentItem.buttons.map((button, index) => (
                  <a
                    key={index}
                    href={button.url}
                    target={button.type === 'pdf' ? '_blank' : '_self'}
                    rel={button.type === 'pdf' ? 'noopener noreferrer' : undefined}
                    className="card-btn"
                  >
                    {button.text}
                  </a>
                ))}
              </div>
            )}

            {/* Legacy support for old link format */}
            {currentItem.link && !currentItem.buttons?.length && (
              <a
                href={currentItem.link}
                download={currentItem.download || false}
                className="card-btn"
              >
                {currentItem.linkText}
              </a>
            )}
          </div>
          <div className="card-image">
            <img src={currentItem.image} alt={currentItem.title} />
          </div>
        </div>
        
        <div className="card-navigation">
          <div className="nav-indicators">
            {data.items.map((_, index) => (
              <button
                key={index}
                className={`nav-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => handleItemSelect(index)}
              />
            ))}
          </div>
          <div className="nav-controls">
            <button className="nav-btn" onClick={handlePrevious}>
              <ChevronLeft size={20} />
            </button>
            <button className="nav-btn" onClick={handleNext}>
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
